// extracted by mini-css-extract-plugin
module.exports = {"svg":"svg--2Abpr"};